function webChat() {
  setInterval(function () {
    const $webchatContainer = $('#__webchat-iframe-container');
    if ($webchatContainer.length) {
      const isMobile = window.innerWidth <= 768;
      const bottomValue = isMobile ? '65px' : '40px';
      $webchatContainer[0].style.setProperty('bottom', bottomValue, 'important');
    }
  }, 100);
}

export default webChat;
